import { render, staticRenderFns } from "./ToggleDetails.vue?vue&type=template&id=cbf0f1cc&"
import script from "./ToggleDetails.vue?vue&type=script&lang=js&"
export * from "./ToggleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports